import { SaveOutlined } from '@ant-design/icons';
import { Checkbox, Col, Form, Input, message, Modal, Row, Spin } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalWidth, ROW_GUTTER } from '@/config';
import { defaultApiErrorHandle } from '@/helpers/errorHandler';
import { apiSdk } from '@/httpClient';
import { getFullName } from '@/helpers/string';

interface Props {
  onClose: () => void;
  cashierId: string;
}
const CashierSellingAssignmentModal = ({ onClose, cashierId }: Props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = React.useState<Array<{ value: any; label: any }>>([]);

  React.useEffect(() => {
    if (cashierId) {
      setLoading(true);
      apiSdk.GlobalCashierSellingAssignmentService.getSellingAssignment({ userId: cashierId })
        .then(res => {
          if (res) {
            form.setFieldsValue({
              name: getFullName(res.cashierFirstName, res.cashierLastName),
              companyIds: res.companyIds,
            });
          } else {
            defaultApiErrorHandle(res);
          }
        })
        .catch(defaultApiErrorHandle)
        .finally(() => {
          setLoading(false);
        });
    }
  }, [cashierId]);
  React.useEffect(() => {
    apiSdk.CompanyService.getAutoCompletion({ pageSize: 1000 }).then(res => {
      setCompanies(res?.map(x => ({ value: x.id, label: x.name })) || []);
    });
  }, []);

  const updateEntity = values => {
    setLoading(true);
    apiSdk.GlobalCashierSellingAssignmentService.saveSellingAssignment({ body: { ...values, cashierId: cashierId } })
      .then(response => {
        if (response?.success) {
          onClose();
          message.success(t('Update success'));
        } else {
          defaultApiErrorHandle(response);
        }
      })
      .catch(error => {
        defaultApiErrorHandle(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      open={true}
      maskClosable={false}
      width={ModalWidth.medium}
      className="nta-custom-form"
      title={'Cashier Selling Assignment'}
      forceRender={true}
      style={{ top: 10 }}
      okText={t('save')}
      cancelText={t('cancel')}
      okButtonProps={{ icon: <SaveOutlined />, className: 'save-btn', loading: loading }}
      onCancel={() => {
        onClose();
      }}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            updateEntity(values);
          })
          .catch(info => {});
      }}
    >
      <Spin spinning={loading}>
        <Form form={form} size="middle" layout="horizontal" labelAlign="right">
          <Form.Item name="id" className="hidden">
            <Input type="hidden" />
          </Form.Item>
          <Row gutter={ROW_GUTTER}>
            <Col md={24}>
              <Form.Item name="name">
                <Input disabled className="input-value-color" />
              </Form.Item>
            </Col>
            <Col md={24}>
              <b>{t('Companies')}</b>
              <Form.Item name="companyIds">
                <Checkbox.Group>
                  <Row gutter={ROW_GUTTER}>
                    {companies.map(p => {
                      return (
                        <Col md={12} key={p.value}>
                          <Checkbox value={p.value}>{p.label}</Checkbox>
                        </Col>
                      );
                    })}
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};
export default CashierSellingAssignmentModal;
